import React from 'react';
import InformeDataCredito from './InformeDataCredito';

const InformeDatacreditoScreen = () => <InformeDataCredito />;

export default InformeDatacreditoScreen;
